var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRollover({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 16.002C2.853 20.098 6.838 23 11.5 23C17.575 23 22.5 18.075 22.5 12M21.75 7.998C20.149 3.901 16.163 1 11.5 1C5.425 1 0.5 5.925 0.5 12M8.5 16H0.5V24M22.5 0V8H14.5",
    stroke: "#944708"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollover);
export default __webpack_public_path__ + "static/media/rollover.1b339eb4e0b553a49737240e813db7be.svg";
export { ForwardRef as ReactComponent };